export enum OrganizationActions {
  Reset = "reset",
  FetchSchedules = "fetchSchedules",
  FetchOrganizations = "fetchOrganizations",
  FetchOrganizationInfo = "fetchOrganizationInfo",
  AddSchedule = "addSchedule",
  EditOrganizationInfo = "editOrganizationInfo",
}
